import { Flex } from "@acko-tech/building-blocks.ui.common";
import {
    AddCouponInputCta,
    AppliedCouponCodeDeiscountText,
    AppliedCouponDetailsContainer,
    AppliedCouponText,
    CouponCardWrapper,
    CouponContainer,
    CouponList,
    Heading,
    HeadingContainer,
    RemoveCouponCta,
    RemoveCouponInputContainer,
    ViewMoreCoupons,
    Wrapper
} from "./styles";
import InputFieldGeneric from "@components/inputField";
import CouponSuccessModal from "@components/couponSuccessModal";
import { getInrFormat } from "@utils/inrFormatter";
import { useContext, useEffect, useState } from "react";
import { Context } from "@components/useContext/context";
import { cardStyles } from "@widgets/ExpandableCard/styles";
import PercentIcon from "@public/images/discount-percentage-icon.svg";
import Coupon from "@components/coupon";
import { getWidgetSpecificProps } from "@utils/index";
import { connect } from "react-redux";
import { CommonProps } from "@utils/interface";
import { ADDANDREMOVE } from "@actions/handleApplyDiscount";
import { analyticEvents as triggerAnalyticEvent } from "@actions/analyticEvents";
import { getRequestpayload } from "@utils/index";

interface IAppliedCoupon {
    code: string;
    coupon_value: number;
    coupon_type: string;
    coupon_display_name: string;
    discount: number;
}

export interface IMultipleCouponCard extends CommonProps {
    cardTitle: string;
    eligibleCoupons: Array<IAppliedCoupon> | [];
    isHiddenCouponApplied: boolean;
    appliedCouponCode: string | null;
    appliedCoupon?: IAppliedCoupon | null;
}

const mapStateToProps = function (state: any, ownProps: any) {
    return getWidgetSpecificProps(
        state.configuration?.normalisedConfig,
        ownProps.id
    );
};

const MultipleCouponCard = (props: any) => {
    const {
        id,
        is_visible,
        eligibleCoupons,
        error,
        isHiddenCouponApplied,
        placeholder,
        appliedCouponCode,
        cardTitle,
        hidden_coupon,
        appliedCoupon,
        actions,
        viewMoreText,
        applyCtaText,
        removeCtaText,
        showCouponAppliedModal,
        couponTickSrc,
        couponIconSrc,
        couponAppliedText,
        availableForSelectedPlan,
        removeCta,
        applyCta,
        appliedText,
        youSavedText
    } = props;

    const { onCouponUpdate } = actions || {};
    const { isDesktop } = useContext(Context);
    const [couponCode, setCouponCode] = useState("");
    const [showInvalidCouponCodeError, setShowInvalidCouponCodeError] =
        useState(!!error);


    useEffect(() => {
        setShowInvalidCouponCodeError(!!error)
    }, [error])

    const [showCouponSuccessModal, setShowCouponSuccessModal] = useState(false);

    useEffect(() => {
        setShowCouponSuccessModal(showCouponAppliedModal);
    }, [showCouponAppliedModal]);

    const [couponList, setCouponList] = useState([
        ...eligibleCoupons.slice(0, 2)
    ]);

    const couponDiscountAmount = appliedCoupon?.discount;

    if (!is_visible) {
        return null;
    }
    const { data, journey } = getRequestpayload();

    const updateEligibleCoupon = async (actionType, coupon) => {
        const updatedData = {
            couponId: coupon.code,
            coupon_display_name: coupon.coupon_display_name,
            status: actionType
        };
        const res = onCouponUpdate[0].funCall(
            //@ts-ignore
            {
                ...onCouponUpdate[0].args,
                data: updatedData
            } || {}
        );

        await triggerAnalyticEvent({
            edata: {
                product: data.product,
                action_name: actionType === ADDANDREMOVE.ADD ? "tap_btn_coupon_added" : "tap_btn_coupon_removed",
                action_type: "tap_btn",
                couponId: coupon.code,
                coupon_display_name: coupon.coupon_display_name,
                status: actionType
            },
            odata: {
                journey
            },
            event_name: "action"
        })
    };

    const updateCustomCoupon = async (actionType) => {
        const updatedData = {
            couponId: actionType === ADDANDREMOVE.REMOVE ? appliedCoupon?.code : couponCode,
            status: actionType
        };
        await onCouponUpdate[0].funCall(
            //@ts-ignore
            {
                ...onCouponUpdate[0].args,
                data: updatedData
            } || {}
        );

        await triggerAnalyticEvent({
            edata: {
                product: data.product,
                action_name: actionType === ADDANDREMOVE.ADD ? "tap_btn_coupon_added" : "tap_btn_coupon_removed",
                action_type: "tap_btn",
                couponId: actionType === ADDANDREMOVE.REMOVE ? appliedCoupon?.code : couponCode,
                status: actionType
            },
            odata: {
                journey
            },
            event_name: "action"
        })
    };

    return (
        <>
            <Wrapper
                styles={cardStyles({
                    show: true,
                    styles: ""
                })}
                id={id}
            >
                <HeadingContainer
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                    isDesktop={isDesktop}
                    id="kaa"
                >
                    <Flex
                        alignItems="center"
                        styles={{
                            boxSizing: "border-box",
                            gap: "8px",
                            width: "auto"
                        }}
                    >
                        <div style={{ width: "24px", height: "24px" }}>
                            <PercentIcon />
                        </div>
                        <Heading>{cardTitle} </Heading>
                    </Flex>
                </HeadingContainer>
                <CouponContainer>
                    {isHiddenCouponApplied ? (
                        <RemoveCouponInputContainer>
                            <AppliedCouponDetailsContainer>
                                <AppliedCouponText>
                                    {appliedCouponCode} {appliedText}
                                    <AppliedCouponCodeDeiscountText>
                                        {youSavedText}
                                        {appliedCoupon?.coupon_type === "percent"
                                            ? `${getInrFormat(appliedCoupon?.discount)}%`
                                            : `₹${getInrFormat(appliedCoupon?.discount)}`}
                                    </AppliedCouponCodeDeiscountText>
                                </AppliedCouponText>
                            </AppliedCouponDetailsContainer>
                            <RemoveCouponCta onClick={() => updateCustomCoupon(ADDANDREMOVE.REMOVE)}>{removeCtaText}</RemoveCouponCta>
                        </RemoveCouponInputContainer>
                    ) : (
                        <div style={{ position: "relative", height: "100%" }}>
                            <InputFieldGeneric
                                errors={{ coupon: error }}
                                touched={{}}
                                placeholder={placeholder}
                                name="coupon"
                                value={couponCode}
                                onChange={(coupon) => {
                                    setCouponCode(coupon.toUpperCase());

                                }}
                                inputContainerStyles={{
                                    marginTop: "0px",
                                    height: "48px",
                                    marginBottom: showInvalidCouponCodeError ? "2rem" : "0px"
                                }}
                                inputStyles={{
                                    border: showInvalidCouponCodeError && "1px solid #D83D37",
                                    boxSizing: "border-box",
                                    height: "48px",
                                }}
                                hideLabelText
                                showError={showInvalidCouponCodeError}
                                setShowError={setShowInvalidCouponCodeError}
                                isDesktop={isDesktop}
                            />
                            <AddCouponInputCta couponCode={couponCode} onClick={() => updateCustomCoupon(ADDANDREMOVE.ADD)}>
                                {applyCtaText}
                            </AddCouponInputCta>
                        </div>
                    )}

                    {eligibleCoupons?.length > 0 && (
                        <CouponList error={showInvalidCouponCodeError}>
                            {couponList?.map((c, i) => {
                                return (
                                    <>
                                        <Coupon
                                            appliedCouponCode={appliedCouponCode}
                                            coupon={c}
                                            addCoupon={() => updateEligibleCoupon(ADDANDREMOVE.ADD, c)}
                                            removeCoupon={() => updateEligibleCoupon(ADDANDREMOVE.REMOVE, c)}
                                            couponDiscountAmount={couponDiscountAmount}
                                            couponTickSrc={couponTickSrc}
                                            couponIconSrc={couponIconSrc}
                                            couponAppliedText={couponAppliedText}
                                            availableForSelectedPlan={availableForSelectedPlan}
                                            removeCta={removeCta}
                                            applyCta={applyCta}
                                        />
                                    </>
                                );
                            })}
                            {eligibleCoupons?.length > 2 &&
                                eligibleCoupons?.length !== couponList?.length && (
                                    <ViewMoreCoupons
                                        onClick={() => {
                                            setCouponList([...eligibleCoupons]);
                                        }}
                                    >
                                        {viewMoreText}
                                    </ViewMoreCoupons>
                                )}
                        </CouponList>
                    )}
                </CouponContainer>
            </Wrapper>

            <CouponSuccessModal
                appliedCoupon={appliedCoupon}
                couponDiscountAmount={couponDiscountAmount}
                showModal={showCouponSuccessModal && couponDiscountAmount}
                setShowModal={setShowCouponSuccessModal}
            />
        </>
    );
};

export default connect(mapStateToProps)(MultipleCouponCard);
